import { useProvider } from '@newfront-insurance/react-provision';
import { useMemo, useRef } from 'react';
import { createNovaTransport } from '../lib/transport';
import { useNovaContext } from '../providers';

/**
 * Hook to create and memoize the Nova chat transport.
 * Uses context values and auth provider to configure the transport.
 * The transport is recreated when context values change.
 */
export function useChatTransport() {
  const {
    userUuid,
    accountUuid,
    authProvider,
    apiEndpoint,
    baseUrl
  } = useNovaContext();
  const {
    getToken
  } = useProvider(authProvider);

  // Use refs to ensure functions always have latest values
  const userUuidRef = useRef(userUuid);
  const accountUuidRef = useRef(accountUuid);
  userUuidRef.current = userUuid;
  accountUuidRef.current = accountUuid;
  const transport = useMemo(() => {
    return createNovaTransport({
      apiEndpoint,
      baseUrl,
      getToken,
      getUserUuid: () => userUuidRef.current,
      getAccountUuid: () => accountUuidRef.current
    });
  }, [apiEndpoint, baseUrl, getToken]);
  return transport;
}